/* eslint-disable @next/next/no-img-element */
import axios from 'axios';
import { motion } from 'framer-motion';
import { sha256 } from 'js-sha256';
import type { NextPage } from 'next';
import Head from 'next/head';
import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useCallback, useEffect, useState } from 'react';
import { FaFacebook, FaInstagram, FaTiktok, FaTwitter, FaYoutube } from "react-icons/fa";
import { SemFoto } from '../../assets';
import { useAuth } from '../../components/context/Info';
import HistoryComponent from '../../components/history/HistoryComponent';
import { AppPhoneInput } from '../../components/input_phone/AppPhoneInput';
import AboutPieces from '../../components/pieces/about/AboutPieces';
import AboutPieces1 from '../../components/pieces/about1/AboutPieces1';
import AboutPieces2 from '../../components/pieces/about1/AboutPieces2';
import { getBlogListServerSideProps } from '../../lib/server/site-props';
import { blogs_busca, blogs_filtros, blogs as getBlogs } from '../../services/menus';
import { sendUser } from '../../services/properties';
import { formatDate, formatSelects, gerarSlug, isColorLight, trackEvent } from '../../utils/FunctionsGlobals';
import { getWithTTL, setWithTTL } from '../../utils/storage';
import { appendCodsiteQuery, buildCanonical } from '../../utils/url';
import WelcomePiecesProperties2 from '../imoveis/components/pieces/properties/welcome2/WelcomePiecesProperties';
import styles from './Property.module.css';

export const getServerSideProps = getBlogListServerSideProps;

interface Blog {
  id: number;
  url_foto: string;
  autor: string;
  titulo: string;
  texto: string;
  excluido: boolean;
  data_cadastro: string;
  id_cidade: number;
  id_empreendimento: number;
  categoria: string;
  id_categoria: number;
}

// Componente de filtro de data
const DateFilter = ({
  filtros,
  buildBlogUrl
}: {
  filtros: any[];
  buildBlogUrl: (_path: string) => string;
}) => {
  const [expandedYears, setExpandedYears] = useState<{[key: string]: boolean}>({});

  const toggleYear = (year: string) => {
    setExpandedYears(prev => ({
      ...prev,
      [year]: !prev[year]
    }));
  };

  return (
    <div className={styles.sidebarWidget}>
      <h3 className={styles.widgetTitle}>Arquivo</h3>
      <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
        {filtros?.map((item: any, idx: number) => (
          <li key={idx} style={{ marginBottom: '8px' }}>
            <div>
              <button 
                onClick={() => toggleYear(item.ano)}
                style={{ 
                  background: 'none', 
                  border: 'none', 
                  color: '#495057', 
                  fontSize: '14px', 
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  width: '100%',
                  textAlign: 'left',
                  padding: '4px 0'
                }}
              >
                <span style={{ marginRight: '8px' }}>
                  {expandedYears[item.ano] ? '▼' : '▶'}
                </span>
                {item.ano}
              </button>
              {expandedYears[item.ano] && (
                <ul style={{ listStyle: 'none', padding: '8px 0 0 20px', margin: 0 }}>
                  {item.meses?.map((mes: string, mesIdx: number) => (
                    <li key={mesIdx} style={{ marginBottom: '4px' }}>
                      <Link 
                        prefetch={false}
                        href={buildBlogUrl(`/blog?ano=${item.ano}&mes=${mes}`)} 
                        style={{ color: '#6c757d', textDecoration: 'none', fontSize: '13px' }}
                      >
                        {mes}
                      </Link>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

const BlogDetailPage: NextPage = () => {
  const router = useRouter();
  const { categoria, cidade, empreendimento, ano, mes,pagina } = router.query;
  const {
      allDataHome,
      isMobile1,
      init_props,
      favorito
  } = useAuth();

  const site = allDataHome?.site;
  const allCities = allDataHome?.cidades ? formatSelects(allDataHome?.cidades,allDataHome?.site?.cidade_priorizada) : [];
  const codsite2 = init_props?.codsite;
  const [relatedBlogs, setRelatedBlogs] = useState<Blog[]>([]);
  const origin = init_props?.prodOrigin
  const withCodsite = useCallback(
    (path: string) => appendCodsiteQuery(path, codsite2, origin),
    [codsite2, origin]
  );
  const canonicalUrl = buildCanonical(init_props?.prodOrigin || site?.site, router.asPath || '/blog');
  const [nome, setNome] = useState('');
  const [email, setEmail] = useState('');
  const [telefone, setTelefone] = useState('');
  const [processando, setProcessando] = useState(false);
  const [enviado, setEnviado] = useState(false);
  const [paginaActual] = useState(pagina ? Number(pagina) : 0);
  const [allFiltros, setAllFiltros] = useState<any>({filtro_data: [],filtro_categoria: [],filtro_cidades: [],filtro_empreendimento: []});
  const [, setHasNextPage] = useState(false);
  const [loading, setLoading] = useState(false);
  const cor_font = isColorLight(site?.cor5) ? site?.cor11 : site?.cor13;

  const cor_fundo = site?.id == 2443 ? "#000000" : site?.id == 2434 ? "#FFFFFF" : site?.id == 2422 || site?.id == 2445 ? site?.cor10 : site?.modelo_topo == 3 || site?.id == 2378 ? site?.cor1 : site?.id == 1890 ? "#f5f5f5" : site?.id == 2231 ? "#000000" : site?.id == 2315 ? "#1c4256"  : site?.id == 2237 ? "#8b8d91"  : site?.id == 1630 ? site?.cor3 : site?.cor1 == "#ffffff" && !site?.navbar_transparente && site?.id != 2311 ? site?.cor3 == "#ffffff" ? "#7a7a7a" : site?.cor3 : site?.id == 2030 ? "#0000008f" : site?.cor1
  const onChangeName = (txt: React.ChangeEvent<HTMLInputElement>) => {
      const { value } = txt.target;
      setNome(value);
  };

  const onChangeTelephone = (value: string) => {
      setTelefone(value);
  };

  const onChangeEmail = (txt: React.ChangeEvent<HTMLInputElement>) => {
      const { value } = txt.target;
      setEmail(value);
  };

  const validaSendUser = async () => {
    if (nome != '' && email != '' && telefone != '' && !processando) {
        const phone = telefone.replace(/[^0-9]/g, '');
        const verifica = isPhoneNumberValid(phone)
        var re = /\S+@\S+\.\S+/;
        if (phone.length > 9 && phone.length < 17 && (site?.internacional || phone.length < 12) && verifica) {
            if (re.test(email) == true) {
                if(!processando){
                    setProcessando(true);
                    actionSendUser();
                }
            } else {
                alert('Preencha um email válido!');
            }
        } else {
            alert('Preencha um número de telefone válido!');
        }
    } else {
        alert(
            'Preencha todos os campos do formulário para enviar sua mensagem!'
        );
    }
};

function isPhoneNumberValid(phoneNumber: string): boolean {
    // Remove todos os caracteres não numéricos
    const cleanedNumber = phoneNumber.replace(/\D/g, '');

    // Verifica se todos os caracteres são iguais
    const allEqual = new Set(cleanedNumber).size === 1;

    // Retorna true se não forem todos iguais
    return !allEqual;
}

const actionSendUser = async () => {
    const getSendUser = await sendUser(
        site?.internacional ? true : false,
        "",
        "",
        "",
        "",
        JSON.stringify(`Estou visitando o blog /blog e desejo receber notícias relacionadas`),
        JSON.stringify(nome),
        JSON.stringify(email),
        JSON.stringify(telefone),
        0,
        0,
        origin || "",
        codsite2 || 0,
        "",
        0
    );

    if(getSendUser?.atendimento?.id_cliente){
        const user = {
            nome,
            telefone,
            email,
        };

        localStorage.setItem('user', JSON.stringify(user));

        if (site?.tag_google_head || site?.google_analytics_head) {
             const eventData = {
              source: "blog",
              client_id: getSendUser?.atendimento?.id_cliente,
              lead_name: nome,
              lead_email: email,
              lead_phone: telefone,
              // ⚠️ evite enviar PII (nome, email, telefone) para GA/GA4
          };
  
          trackEvent("generate_lead", eventData);
          trackEvent("lead_submit_success", eventData);
        }

        const getCookie = (name: string) =>
            document.cookie
            .split('; ')
            .find((row) => row.startsWith(name + '='))
        ?.split('=')[1] || ''

        if (site?.fb_token_pixel && site?.fb_id_pixel) {
            // Defina seu access token e ID do Pixel do Facebook
            const accessToken = site?.fb_token_pixel;
            const pixelId = site?.fb_id_pixel;
            const currentTimestampInSeconds = Math.floor(new Date().getTime() / 1000);
            const normalizedName = nome.trim().toLowerCase();
            const normalizedEmail = email.trim().toLowerCase();
            const normalizedPhone = telefone.replace(/\D/g, ''); // Apenas números

            // Hash dos dados
            const hashNome = sha256(normalizedName);
            const hashEmail = sha256(normalizedEmail);
            const hashTelefone = sha256(normalizedPhone);
            const fbc = getCookie('_fbc')
            const fbp = getCookie('_fbp')

            let clientIpAddress: string
            try {
                const res6 = await axios.get<{ ip: string }>(
                'https://api6.ipify.org?format=json'
                )
                clientIpAddress = res6.data.ip
            } catch {
                const res4 = await axios.get<{ ip: string }>(
                'https://api.ipify.org?format=json'
                )
                clientIpAddress = res4.data.ip
            }

            // Dados do evento
            const eventData = [
                {
                event_name: 'Lead',
                event_time: currentTimestampInSeconds,
                action_source: 'website',
                event_source_url: 'https://' + site?.site,
                user_data: {
                    fn: [hashNome],
                    em: [hashEmail],
                    ph: [hashTelefone],
                    fbc: fbc || undefined,
                    fbp: fbp || undefined,
                    client_ip_address: clientIpAddress
                }
            }];

            axios.post(
                `https://graph.facebook.com/v12.0/${pixelId}/events?access_token=${accessToken}`,
                { data: eventData }
            )
                .then(response => {
                console.log('Evento registrado com sucesso:', response.data);
                })
                .catch(error => {
                console.error('Erro ao registrar evento:', error?.response?.data || error.message);
            });
        }
    }

    setEnviado(true)
    setProcessando(false);
};

 const renderRodape = () => {
      switch (site?.rodape) {
          case 1:
              return (
                  <motion.div
                      initial={{ opacity: 0, y: 40 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
                      viewport={{ once: true, amount: 0.22 }}
                  >
                      <AboutPieces1 site={site} allCities={allCities} allCitiesTipes={allDataHome?.tipos} codsite={codsite2} origin={origin} isMobile={isMobile1} allRodape={allDataHome?.rodape} favorito={favorito}/>
                  </motion.div>
              );
          case 2:
              return (
                  <AboutPieces allRodape={allDataHome?.rodape} site={site} allCities={allCities} allCitiesTipes={allDataHome?.tipos} codsite={codsite2} origin={origin} isMobile={isMobile1}/>
              );
          case 3:
              return (
                  <AboutPieces2 site={site} allRodape={allDataHome?.rodape}/>
              );
          default:
          return (
              <motion.div
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
                  viewport={{ once: true, amount: 0.22 }}
              >
                  <AboutPieces1 site={site} allCities={allCities} allCitiesTipes={allDataHome?.tipos} codsite={codsite2} origin={origin} isMobile={isMobile1} allRodape={allDataHome?.rodape} favorito={favorito}/>
              </motion.div>
          );
      }
  }

  useEffect(() => {
    const fetchBlogData = async () => {
      try {
        setLoading(true);
        
        // Cache key para a consulta
        const cacheKey = `blog_busca_${cidade || 0}_${empreendimento || 0}_${categoria || 0}_${ano || 0}_${mes || 0}_${paginaActual}_${init_props?.codsite}`;
        
        // Tentar buscar do cache primeiro (30 minutos de TTL)
        let blogs_categoria: any = getWithTTL(cacheKey);
        
        if (!blogs_categoria) {
          blogs_categoria = await blogs_busca(cidade ? Number(cidade) : 0,empreendimento ? Number(empreendimento) : 0,categoria ? Number(categoria) : 0,ano ? Number(ano) : 0,mes ? Number(mes) : 0,paginaActual, origin,init_props?.codsite);
          // Salvar no cache por 30 minutos]
          setWithTTL(cacheKey, blogs_categoria, 30 * 60 * 1000);
        }
        
        if(blogs_categoria?.blogsBusca?.length == 0){
          const blogsResponse = await getBlogs(origin,init_props?.codsite);
          const allBlogs = blogsResponse?.blogs || [];
          const activeBlogs = allBlogs.filter((b: Blog) => !b.excluido);

          if(activeBlogs?.length > 0)
            setRelatedBlogs(activeBlogs);
          else 
            router.replace(`/`)
        } else {
          const allBlogs = blogs_categoria?.blogsBusca || [];
          if(allBlogs?.length > 0){
            setRelatedBlogs(allBlogs);
            // Se retornou exatamente 20 items, provavelmente há mais páginas
            setHasNextPage(blogs_categoria.blogsBusca.length === 20);
          } else {
            router.replace(`/`)
          }
        }

        // Cache para filtros
        const filtrosCacheKey = `blog_filtros_${init_props?.codsite}`;
        let allFiltros: any = getWithTTL(filtrosCacheKey);
        
        if (!allFiltros) {
          allFiltros = await blogs_filtros(origin,init_props?.codsite);
     
          setWithTTL(filtrosCacheKey, allFiltros, 30 * 60 * 1000);
        }
        if(allFiltros)
          setAllFiltros(allFiltros?.blogs_filtros)
      } catch (error) {
        console.error('Erro ao carregar dados do blog', error);
      } finally {
        setLoading(false);
      }
    };

    fetchBlogData();
  }, [categoria, cidade, empreendimento, ano, mes, paginaActual, origin, init_props?.codsite, router]);

  useEffect(() => {
    try {
        const getUser: any = localStorage.getItem('user');
        if(getUser){
          const user = JSON.parse(getUser)
          if(user?.email)
            setEmail(user?.email)
            setNome(user?.nome)
            setTelefone(user?.telefone)
        }
    } catch (error) {
      console.log(error)
    }
  }, []);

  const initialFlow: any = [
        'home',
        'blog'
    ];

  // Se não há blog específico, mostra lista de blogs

  return (
    <>
      <Head>
        <title>Blog</title>
        <meta name="description" content={'Blog'} />
        <meta name="keywords" content={site?.meta_keywords ? site?.meta_keywords : `Imobiliária, imóveis, imóveis à venda, imóveis em ${site?.Dados?.cidade}`}/>
        <meta property="og:title" content={'Blog'} />
        <meta property="og:description" content={'Blog'} />
        <meta property="og:image" content={site?.id == 1616 ? "https://imob.sobressai.com.br/Banner/1616/11880.jpg" : site?.url_logo} />
        <meta property="og:type" content="article" />
        <meta property="og:url" content={canonicalUrl} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={'Blog'} />
        <meta name="twitter:description" content={'Blog'} />
        <meta name="twitter:image" content={site?.url_logo} />
        <meta name="author" content={site?.Dados?.empresa} />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={canonicalUrl} key="canonical" />
        <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css" />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "Article",
              "headline": "Blog",
              "image": site?.url_logo,
              "author": {
                "@type": "Person",
                "name": site?.Dados?.empresa
              },
              "publisher": {
                "@type": "Organization",
                "name": site?.Dados?.empresa,
                "logo": {
                  "@type": "ImageObject",
                  "url": "/assets/images/sem_foto.png"
                }
              },
              "datePublished": relatedBlogs[0]?.data_cadastro ? formatDate(relatedBlogs[0]?.data_cadastro) : "",
              "dateModified": relatedBlogs[0]?.data_cadastro ? formatDate(relatedBlogs[0]?.data_cadastro) : "",
              "description": relatedBlogs[0]?.texto ? relatedBlogs[0].texto.replace(/<[^>]*>/g, '').substring(0, 160) : '',
              "mainEntityOfPage": {
                "@type": "WebPage",
                "@id": canonicalUrl
              }
            })
          }}
        />
      </Head>

      <div className={styles.container}>
        <div className={styles.header_welcome}>
          <WelcomePiecesProperties2
            site={site}
            favorito={favorito}
            props={allDataHome}
          />
          <HistoryComponent site={site} routes={initialFlow} pagina={1}/>
        </div>
        <div className={styles.titleSection}>
          <h1 className={styles.pageTitle} style={{color: cor_font}}>
            {categoria ? `Blog - ${allFiltros?.filtro_categoria?.find((cat: any) => cat.id_categoria == categoria)?.nome || 'Categoria'}` : 'Blog'}
          </h1>
          {(categoria || cidade || empreendimento || ano || mes) && (
            <p className={styles.subtitle} style={{color: cor_font}}>
              Resultados filtrados {relatedBlogs.length > 0 && `• ${relatedBlogs.length} artigos encontrados`}
            </p>
          )}
        </div>

        <main className={styles.main}>
          <div className={styles.theiaStickySidebar} style={{background: site?.cor5}}>
            {loading ? (
              <div className={styles.loading} style={{color: cor_font}}>
                <p>Carregando artigos...</p>
              </div>
            ) : (
              <>
              {/* Widget do Corretor/Imobiliária */}
              <div className={styles.sidebarWidget}>
                <h3 className={styles.widgetTitle}>{site?.Dados?.empresa}</h3>
                <div className={styles.brokerInfo}>
                  <Image
                    src={site?.url_logo || SemFoto.src}
                    alt="Logo empresa"
                    style={{background: cor_fundo}}
                    className={styles.brokerAvatar}
                    width={80}
                    height={80}
                    sizes="80px"
                    onError={(e) => {
                        (e.currentTarget as HTMLImageElement).src = SemFoto.src;
                    }}
                  />
                  {site?.Dados?.empresa && <h4 className={styles.brokerName}>{site?.Dados?.empresa}</h4>}
                  {site?.Dados?.cidade && <p className={styles.brokerTitle}>{`Imobiliária em ${site?.Dados?.cidade}`}</p>}
                  {site?.Dados?.creci && <p className={styles.brokerTitle}>{`Creci ${site?.Dados?.creci}`}</p>}
                  {allDataHome?.banner_empresa?.paragrafo_1 || site?.meta_description ?
                    <p className={styles.brokerDescription}>
                      {allDataHome?.banner_empresa?.paragrafo_1 ? allDataHome?.banner_empresa?.paragrafo_1 : site?.meta_description}
                    </p>
                  : null}

                  <div className={styles.socialLinks}>
                    {site?.Dados?.facebook && 
                      <a href={site?.Dados?.facebook} className={`${styles.socialLink} ${styles.facebook}`} data-no-quicklink    
                                data-no-instant      
                                data-no-prefetch     
                                rel="nofollow">
                        <FaFacebook/>
                      </a>
                    }
                    {site?.Dados?.instagram && 
                      <a href={site?.Dados?.instagram} className={`${styles.socialLink} ${styles.instagram}`} data-no-quicklink    
                                data-no-instant      
                                data-no-prefetch     
                                rel="nofollow">
                        <FaInstagram/>
                      </a>
                    }
                    {site?.Dados?.twitter && 
                      <a href={site?.Dados?.twitter} className={`${styles.socialLink} ${styles.twitter}`} data-no-quicklink    
                                data-no-instant      
                                data-no-prefetch     
                                rel="nofollow">
                        <FaTwitter/>
                      </a>
                    }
                    {site?.Dados?.youtube && 
                      <a href={site?.Dados?.youtube} className={`${styles.socialLink} ${styles.youtube}`} data-no-quicklink    
                                data-no-instant      
                                data-no-prefetch     
                                rel="nofollow">
                        <FaYoutube/>
                      </a>
                    }
                    {site?.Dados?.tiktok && 
                      <a href={site?.Dados?.tiktok} className={`${styles.socialLink} ${styles.youtube}`} data-no-quicklink    
                                data-no-instant      
                                data-no-prefetch     
                                rel="nofollow">
                        <FaTiktok/>
                      </a>
                    }
                  </div>
                </div>
              </div>
                {relatedBlogs.length > 0 && (
                  <div className={styles.postRelated}>
                    <div className={styles.relatedGrid}>
                      {relatedBlogs.map((relatedBlog) => (
                      <div key={relatedBlog.id} className={styles.itemRelated}>
                        <Link
                          prefetch={false}
                          href={withCodsite(`/blog/${gerarSlug(relatedBlog?.titulo || "")}/${relatedBlog.id}`)}
                          className={styles.relatedThumb}
                        >
                          <img
                            src={relatedBlog.url_foto || SemFoto.src}
                            alt={relatedBlog.titulo}
                            className={styles.relatedImage}
                            onError={(e) => {
                                e.currentTarget.src = SemFoto.src;
                            }}
                          />
                        </Link>
                        <h3 className={styles.relatedTitle}>
                          <Link href={withCodsite(`/blog/${gerarSlug(relatedBlog?.titulo || "")}/${relatedBlog.id}`)} prefetch={false}>
                            {relatedBlog.titulo.length > 60 ?
                              relatedBlog.titulo.substring(0, 60) + '...' :
                              relatedBlog.titulo
                            }
                          </Link>
                        </h3>
                      </div>
                  ))}
                  </div>
                </div>
                
              )}
              
          </>)}
          </div>

          {/* Sidebar */}
          <aside className={styles.sidebar}>
            {/* Newsletter */}
            {!enviado &&
              <div className={styles.sidebarWidget}>
                <h3 className={styles.widgetTitle}>Receba Novidades</h3>
                <p style={{ marginBottom: '15px', fontSize: '14px', lineHeight: '1.6' }}>
                  Cadastre-se para receber as últimas notícias do mercado imobiliário diretamente no seu email.
                </p>
                <form className={styles.newsletterForm}>
                  <input
                      className={styles.newsletterInput}
                      placeholder="Nome"
                      value={nome}
                      onChange={onChangeName}
                      required
                  />
                  <AppPhoneInput
                      id="Telefone_id"
                      value={telefone}
                      onChange={onChangeTelephone}
                      placeholder="Telefone"
                      defaultCountry="BR"
                      width_max={100}
                      inputHeight={40}
                      limitMaxLength={true}
                      inputClassName={styles.newsletterInput}
                      semPais={!site?.internacional ? true : false}
                      includeCountryCode={site?.internacional ? true : false} 
                  />
                  <input
                      className={styles.newsletterInput}
                      placeholder="Email"
                      value={email}
                      onChange={onChangeEmail}
                      required
                  />
                  <div className={styles.adjust_checkbox}>
                      <div className={styles.description_form}>
                          Ao enviar concordo com os
                          <Link prefetch={false} href="/termos">
                              <div className={styles.terms}>
                                  termos de uso
                              </div>
                          </Link>
                          e
                          <Link prefetch={false} href="/politica">
                              <div className={styles.terms}>
                                  política de privacidade
                              </div>
                          </Link>
                      </div>
                  </div>
                  <button 
                    onClick={async (e) => {
                      e.preventDefault();
                      await validaSendUser(); // <-- Aqui você está chamando a função de verdade
                    }} className={processando || !email || !nome || !telefone ? styles.newsletterButtonBlock : styles.newsletterButton}>
                    Cadastrar Agora
                  </button>
                </form>
              </div>
            }

            {/* Posts Populares */}
            <div className={styles.sidebarWidget}>
              <h3 className={styles.widgetTitle}>Posts Populares</h3>
              <ul className={styles.popularPosts}>
                {relatedBlogs.slice(0, 4).map((blog) => (
                  <li key={blog.id} className={styles.popularPost}>
                    <div className={styles.popularPostThumb}>
                      <img
                        src={blog.url_foto || SemFoto.src}
                        alt={blog.titulo}
                        className={styles.popularPostImage}
                        onError={(e) => {
                            e.currentTarget.src = SemFoto.src;
                        }}
                      />
                    </div>
                    <div className={styles.popularPostContent}>
                      <h4 className={styles.popularPostTitle}>
                        <Link href={withCodsite(`/blog/${gerarSlug(blog?.titulo || "")}/${blog.id}`)} prefetch={false}>
                          {blog.titulo.length > 45 ? blog.titulo.substring(0, 45) + '...' : blog.titulo}
                        </Link>
                      </h4>
                      <span className={styles.popularPostDate}>
                        {formatDate(blog.data_cadastro)}
                      </span>
                    </div>
                  </li>
                ))}
              </ul>
            </div>

            {/* Categorias */}
            {allFiltros?.filtro_categoria?.length > 0 ?
            <div className={styles.sidebarWidget}>
              <h3 className={styles.widgetTitle}>Categorias</h3>
              <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                {allFiltros?.filtro_categoria.map((cat: any, idx: number) => (
                  <li style={{ marginBottom: '8px' }} key={idx}>
                    <Link prefetch={false} href={withCodsite(`/blog?categoria=${cat?.id_categoria}`)} style={{ color: '#495057', textDecoration: 'none', fontSize: '14px' }}>
                      {cat?.nome}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>: null}

            {allFiltros?.filtro_cidades?.length > 0 ?
            <div className={styles.sidebarWidget}>
              <h3 className={styles.widgetTitle}>Cidades</h3>
              <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                {allFiltros?.filtro_cidades.map((cit: any, idx: number) => (
                  <li style={{ marginBottom: '8px' }} key={idx}>
                    <Link prefetch={false} href={withCodsite(`/blog?cidade=${cit?.id_cidade}`)} style={{ color: '#495057', textDecoration: 'none', fontSize: '14px' }}>
                      {cit?.nome}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>: null}

            {allFiltros?.filtro_empreendimento?.length > 0 ?
            <div className={styles.sidebarWidget}>
              <h3 className={styles.widgetTitle}>Empreendimentos</h3>
              <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                {allFiltros?.filtro_empreendimento.map((emp: any, idx: number) => (
                  <li style={{ marginBottom: '8px' }} key={idx}>
                    <Link prefetch={false} href={withCodsite(`/blog?empreendimento=${emp?.id_empreendimento}`)} style={{ color: '#495057', textDecoration: 'none', fontSize: '14px' }}>
                      {emp?.nome}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>: null}

            {/* Filtro de Data */}
            {allFiltros?.filtro_data?.length > 0 && (
              <DateFilter filtros={allFiltros.filtro_data} buildBlogUrl={withCodsite} />
            )}
          </aside>
        </main>
      </div>
        { renderRodape() }
    </>
  );
};

export default BlogDetailPage;
